import React from "react";
import assets from "../../../shared/constants/assetVariables";
const csrdReportingFeature = [
  {
    id: "1",
    icon: assets.icons.csrdReportIcon1,
    heading: "Automated Report Generation",
    description: "Structured CSRD reports formatted per ESRS disclosure requirements.",
  },
  {
    id: "2",
    icon: assets.icons.csrdReportIcon2,
    heading: "Track Report Progress",
    description: "Users can monitor the completion status of each section.",
  },
  {
    id: "3",
    icon: assets.icons.csrdReportIcon3,
    heading: "Version Control & Auditability",
    description: "Ensures transparency and tracks data modifications for compliance.",
  },
  {
    id: "4",
    icon: assets.icons.csrdReportIcon4,
    heading: "Cross-Framework Comparisons",
    description: "Provides insights into alignment with other ESG frameworks.",
  },
  {
    id: "5",
    icon: assets.icons.csrdReportIcon5,
    heading: "Export & Reporting",
    description: "Generate CSRD reports in multiple formats, including XBRL, PDF, and HTML.",
  },
];
function Section_5() {
  return (
    <section className="csrd-landing-page-section-5-container">
      <div className="csrd-landing-page-section-5-header-container">
        <div
          className="csrd-landing-page-section-5-header"
          data-aos="fade-down"
          data-aos-delay="50"
          data-aos-duration="700"
          data-aos-once="true">
          <span className="text-1">CSRD</span> <span className="text-2">Reporting</span>
        </div>
        <div
          className="csrd-landing-page-section-5-description"
          data-aos="fade-up"
          data-aos-delay="50"
          data-aos-duration="700"
          data-aos-once="true">
          With seamless data collection and validation, Updapt enables the generation of an
          automated CSRD report aligned with the CSRD framework.
        </div>
      </div>
      <div
        className="key-feature-heading"
        data-aos="zoom-in"
        data-aos-delay="50"
        data-aos-duration="700"
        data-aos-once="true">
        Key Features
      </div>
      <div className="key-feature-content-container">
        <div className="key-feature-inner-content-container">
          <div className="key-feature-left-container">
            <div
              className="dash-circle"
              data-aos="zoom-in-right"
              data-aos-delay="50"
              data-aos-duration="700"
              data-aos-once="true">
              <div className="dash-circle-11">
                <div className="dash-circle-22">
                  <div className="solid-green-circle"></div>
                </div>
              </div>
            </div>
            <div
              className="csrd-reporting-img-container"
              data-aos="fade-right"
              data-aos-delay="50"
              data-aos-duration="700"
              data-aos-once="true">
              <div className="csrd_report_img1_container">
                <img
                  src={assets.images.csrdReport_img1}
                  alt="csrd-reporting-img1"
                  loading="lazy"
                  className="csrd_report_img1"
                />
              </div>

              <div className="csrd_report_img2_container">
                <img
                  src={assets.images.csrdReport_img2}
                  alt="csrd-reporting-img2"
                  loading="lazy"
                  className="csrd_report_img2"
                />
              </div>
            </div>
          </div>
          <div
            className="key-feature-right-container"
            data-aos="fade-up"
            data-aos-delay="50"
            data-aos-duration="700"
            data-aos-once="true">
            <div className="solid-green-circle-right"></div>
            {csrdReportingFeature?.map((ele) => {
              return (
                <div className="key-feature-card-container" key={ele?.id}>
                  <div className="dma-icon">
                    <img src={ele?.icon} alt="dm1-icon" />
                  </div>
                  <div className="feature-header-description-container">
                    <div className="feature-header">{ele?.heading}</div>
                    <div className="feature-description">{ele?.description}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Section_5;
